import React from 'react';
import {ModelActionProps} from '../../../../actionMenuTypes';
import {MODEL_ACTION_MENU_IDS} from '../../../../../../test/types';
import SideBarButtonItem from '../../../../../layout/common/SideBarButtonItem';
import {tid} from '../../../../../../testUtils';
import {canEditModel} from '../../../../../../permissions/usePermissions';
import {useModelEditMetadataSideBarModal} from './useModelEditMetadataSideBarModal';
import {CategoryNewEach16} from '@carbon/icons-react';
import {DatabaseOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import {getUrlRoute, MRAppRoutes} from '../../../../../router/routes';

const ModelEditMetadataActionMenuButton: React.FC<Partial<ModelActionProps>> = (props) => {
  const navigate = useNavigate();
  const {ModalComponent, openModal} = useModelEditMetadataSideBarModal(props);
  const handleClick = (event?: any) => {
    if (props.newDesign && props.model?.uuid) {
      navigate(
        getUrlRoute(MRAppRoutes.MODEL_UPLOAD, {
          uuid: props.model.uuid,
          editMode: 'true',
          editStep: 'metadata',
        } as any),
      );
      return;
    }
    openModal(event);
  };

  return (
    <>
      <SideBarButtonItem
        {...tid(MODEL_ACTION_MENU_IDS.EDIT_METADATA)}
        permission={canEditModel(props.model)}
        onClick={handleClick}
        icon={props.newDesign ? <DatabaseOutlined style={{strokeWidth: '6px'}} /> : <CategoryNewEach16 />}
        text="Edit Metadata"
      />
      {!props.newDesign && ModalComponent}
    </>
  );
};

export default ModelEditMetadataActionMenuButton;
